
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import Url from "@/lib/common/url";
import Auth from "@/lib/common/auth";
import _ from "lodash-es";
import { ExamInfo } from "@/lib/model/exam/candidate";
import EditStatus from "@/components/edit-status.vue";
import config from "@/config/config";
@Component({
  components: {
    AuthHeader,
    EditStatus
  }
})
export default class Edit extends Vue {
  isAnonymous = false;
  paperId = "";
  status = "";
  exam = new ExamInfo();
  mounted() {
    this.paperId = Url.query("paperId");
    this.status = Url.query("status");
    Auth.init()
      .then(() => {
        this.isAnonymous = false;
        if (_.isEmpty(this.paperId) && _.isEmpty(this.status)) {
          this.$message.error("访问地址错误");
          return;
        }
        (async () => {
          await this.getExamx();
        })();
      })
      .catch(() => {
        this.isAnonymous = false;
      });
  }
  isStatusAdd() {
    return this.status == "add";
  }
  isStatusEdit() {
    return this.status == "edit";
  }
  isDisabled() {
    return this.exam.closeUpdate == 1;
  }
  goBackToList() {
    window.location.href = `${config.apiUrl}/exam/paper?cid=${Auth.companyId}`;
  }
  // 获取考试信息
  async getExamx() {
    this.exam = await ExamInfo.getInfo(this.paperId);
  }

  toStepOne() {
    window.location.href = `${config.apiUrl}/paper-info?paperId=${this.paperId}&status=add&cid=${Auth.companyId}`;
  }
  toStepThree() {
    this.$router.push({
      path: "/paper/finish",
      query: {
        paperId: this.paperId
      }
    });
  }
  toQuestionSelect() {
    this.$router.push({
      path: "/question/select",
      query: {
        paperId: this.paperId
      }
    });
  }
}
